import { Facebook, Instagram, Linkedin, MessageCircle } from 'lucide-react';
import { SOCIAL_LINKS } from '@/lib/constants';

const ICONS = {
  Instagram,
  Facebook,
  Linkedin,
  MessageCircle,
} as const;

interface SocialLinksProps {
  variant?: 'horizontal' | 'compact';
  className?: string;
}

/**
 * Iconos a las redes sociales oficiales de Oro Express.
 * Configuradas en `SOCIAL_LINKS` de `lib/constants.ts`.
 */
export function SocialLinks({
  variant = 'horizontal',
  className = '',
}: SocialLinksProps) {
  return (
    <ul
      className={`flex flex-wrap items-center ${
        variant === 'compact' ? 'gap-2' : 'gap-3'
      } ${className}`}
      aria-label="Redes sociales de Oro Express"
    >
      {SOCIAL_LINKS.map((s) => {
        const Icon = ICONS[s.icon as keyof typeof ICONS];
        return (
          <li key={s.name}>
            <a
              href={s.url}
              target="_blank"
              rel="noopener noreferrer me"
              aria-label={`${s.name} (${s.handle})`}
              title={`${s.name} · ${s.handle}`}
              className="group inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-cream/70 transition-all hover:-translate-y-0.5 hover:border-gold-500/40 hover:bg-gold-500/10 hover:text-gold-200"
            >
              <Icon className="h-4.5 w-4.5" aria-hidden />
            </a>
          </li>
        );
      })}
    </ul>
  );
}
